import right_triangle from "src/img/right_triangle.svg"

const MemoSection = ({ register, myMemo, setMyMemo, copyMemoToDaily, isEditMode }) => {

  return (
    <div className="work-contents-container" style={{ display: "flex" }}>
      <div className="my_memo" style={{ width: "45%" }}>
        <h2 className="h4 h-style-a">
          <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span> mymemo
        </h2>
        <div className="work-contents">
          <textarea
            className="form-control"
            placeholder="MEMO"
            value={myMemo}
            onChange={(e) => setMyMemo(e.target.value)}
          />
          
        </div>
      </div>
      <div className="copy_to_daily_memo">
        <a href="#" className="copy_to_daily_memo_btn" 
          onClick={(e) => { 
            e.preventDefault();
            copyMemoToDaily(); 
          }}
          >
          <img src={right_triangle || "/placeholder.svg"} alt="コピー" />
        </a>
      </div>
      <div className="daily_memo" style={{ width: "45%" }}>
        <h2 className="h4 h-style-a">
          <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span> mamemo (Today)
        </h2>
        <div className="work-contents">
          <textarea className="form-control" placeholder="MEMO" {...register("daily_memo")} />
        </div>
      </div>
    </div>
  )
}

export default MemoSection

